/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MasterLayoutRouteImport } from './routes/_master-layout'
import { Route as IndexRouteImport } from './routes/index'
import { Route as MasterLayoutLoginRouteImport } from './routes/_master-layout/login'
import { Route as MasterLayoutDashboardLayoutRouteImport } from './routes/_master-layout/_dashboard-layout'
import { Route as MasterLayoutDashboardLayoutShiftsIndexRouteImport } from './routes/_master-layout/_dashboard-layout/shifts.index'
import { Route as MasterLayoutDashboardLayoutShiftsCreateRouteImport } from './routes/_master-layout/_dashboard-layout/shifts.create'
import { Route as MasterLayoutDashboardLayoutShiftsIdRouteImport } from './routes/_master-layout/_dashboard-layout/shifts.$id'

const MasterLayoutRoute = MasterLayoutRouteImport.update({
  id: '/_master-layout',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const MasterLayoutLoginRoute = MasterLayoutLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => MasterLayoutRoute,
} as any)
const MasterLayoutDashboardLayoutRoute =
  MasterLayoutDashboardLayoutRouteImport.update({
    id: '/_dashboard-layout',
    getParentRoute: () => MasterLayoutRoute,
  } as any)
const MasterLayoutDashboardLayoutShiftsIndexRoute =
  MasterLayoutDashboardLayoutShiftsIndexRouteImport.update({
    id: '/shifts/',
    path: '/shifts/',
    getParentRoute: () => MasterLayoutDashboardLayoutRoute,
  } as any)
const MasterLayoutDashboardLayoutShiftsCreateRoute =
  MasterLayoutDashboardLayoutShiftsCreateRouteImport.update({
    id: '/shifts/create',
    path: '/shifts/create',
    getParentRoute: () => MasterLayoutDashboardLayoutRoute,
  } as any)
const MasterLayoutDashboardLayoutShiftsIdRoute =
  MasterLayoutDashboardLayoutShiftsIdRouteImport.update({
    id: '/shifts/$id',
    path: '/shifts/$id',
    getParentRoute: () => MasterLayoutDashboardLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof MasterLayoutLoginRoute
  '/shifts/$id': typeof MasterLayoutDashboardLayoutShiftsIdRoute
  '/shifts/create': typeof MasterLayoutDashboardLayoutShiftsCreateRoute
  '/shifts/': typeof MasterLayoutDashboardLayoutShiftsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof MasterLayoutLoginRoute
  '/shifts/$id': typeof MasterLayoutDashboardLayoutShiftsIdRoute
  '/shifts/create': typeof MasterLayoutDashboardLayoutShiftsCreateRoute
  '/shifts': typeof MasterLayoutDashboardLayoutShiftsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_master-layout': typeof MasterLayoutRouteWithChildren
  '/_master-layout/_dashboard-layout': typeof MasterLayoutDashboardLayoutRouteWithChildren
  '/_master-layout/login': typeof MasterLayoutLoginRoute
  '/_master-layout/_dashboard-layout/shifts/$id': typeof MasterLayoutDashboardLayoutShiftsIdRoute
  '/_master-layout/_dashboard-layout/shifts/create': typeof MasterLayoutDashboardLayoutShiftsCreateRoute
  '/_master-layout/_dashboard-layout/shifts/': typeof MasterLayoutDashboardLayoutShiftsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/login' | '/shifts/$id' | '/shifts/create' | '/shifts/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/login' | '/shifts/$id' | '/shifts/create' | '/shifts'
  id:
    | '__root__'
    | '/'
    | '/_master-layout'
    | '/_master-layout/_dashboard-layout'
    | '/_master-layout/login'
    | '/_master-layout/_dashboard-layout/shifts/$id'
    | '/_master-layout/_dashboard-layout/shifts/create'
    | '/_master-layout/_dashboard-layout/shifts/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  MasterLayoutRoute: typeof MasterLayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_master-layout': {
      id: '/_master-layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MasterLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_master-layout/login': {
      id: '/_master-layout/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof MasterLayoutLoginRouteImport
      parentRoute: typeof MasterLayoutRoute
    }
    '/_master-layout/_dashboard-layout': {
      id: '/_master-layout/_dashboard-layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MasterLayoutDashboardLayoutRouteImport
      parentRoute: typeof MasterLayoutRoute
    }
    '/_master-layout/_dashboard-layout/shifts/': {
      id: '/_master-layout/_dashboard-layout/shifts/'
      path: '/shifts'
      fullPath: '/shifts/'
      preLoaderRoute: typeof MasterLayoutDashboardLayoutShiftsIndexRouteImport
      parentRoute: typeof MasterLayoutDashboardLayoutRoute
    }
    '/_master-layout/_dashboard-layout/shifts/create': {
      id: '/_master-layout/_dashboard-layout/shifts/create'
      path: '/shifts/create'
      fullPath: '/shifts/create'
      preLoaderRoute: typeof MasterLayoutDashboardLayoutShiftsCreateRouteImport
      parentRoute: typeof MasterLayoutDashboardLayoutRoute
    }
    '/_master-layout/_dashboard-layout/shifts/$id': {
      id: '/_master-layout/_dashboard-layout/shifts/$id'
      path: '/shifts/$id'
      fullPath: '/shifts/$id'
      preLoaderRoute: typeof MasterLayoutDashboardLayoutShiftsIdRouteImport
      parentRoute: typeof MasterLayoutDashboardLayoutRoute
    }
  }
}

interface MasterLayoutDashboardLayoutRouteChildren {
  MasterLayoutDashboardLayoutShiftsIdRoute: typeof MasterLayoutDashboardLayoutShiftsIdRoute
  MasterLayoutDashboardLayoutShiftsCreateRoute: typeof MasterLayoutDashboardLayoutShiftsCreateRoute
  MasterLayoutDashboardLayoutShiftsIndexRoute: typeof MasterLayoutDashboardLayoutShiftsIndexRoute
}

const MasterLayoutDashboardLayoutRouteChildren: MasterLayoutDashboardLayoutRouteChildren =
  {
    MasterLayoutDashboardLayoutShiftsIdRoute:
      MasterLayoutDashboardLayoutShiftsIdRoute,
    MasterLayoutDashboardLayoutShiftsCreateRoute:
      MasterLayoutDashboardLayoutShiftsCreateRoute,
    MasterLayoutDashboardLayoutShiftsIndexRoute:
      MasterLayoutDashboardLayoutShiftsIndexRoute,
  }

const MasterLayoutDashboardLayoutRouteWithChildren =
  MasterLayoutDashboardLayoutRoute._addFileChildren(
    MasterLayoutDashboardLayoutRouteChildren,
  )

interface MasterLayoutRouteChildren {
  MasterLayoutDashboardLayoutRoute: typeof MasterLayoutDashboardLayoutRouteWithChildren
  MasterLayoutLoginRoute: typeof MasterLayoutLoginRoute
}

const MasterLayoutRouteChildren: MasterLayoutRouteChildren = {
  MasterLayoutDashboardLayoutRoute:
    MasterLayoutDashboardLayoutRouteWithChildren,
  MasterLayoutLoginRoute: MasterLayoutLoginRoute,
}

const MasterLayoutRouteWithChildren = MasterLayoutRoute._addFileChildren(
  MasterLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  MasterLayoutRoute: MasterLayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
